import type { SVGProps } from 'react'

export const AddPlusSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.3333 35H12.5C8.35786 35 5 31.6421 5 27.5V12.5C5 8.35786 8.35786 5 12.5 5H27.5C31.6421 5 35 8.35786 35 12.5V18.3333"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="30.0002"
      cy="30.0007"
      r="6.66667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.0832 29.9988L27.9165 29.9999"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M29.9993 27.916L30.0004 32.0827"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="16.6668"
      cy="15.8333"
      r="3.33333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6665 12.5C18.5075 12.5 19.9998 13.9924 19.9998 15.8333C19.9998 17.6743 18.5075 19.1667 16.6665 19.1667"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.1406 12.5C25.9816 12.5 27.474 13.9924 27.474 15.8333C27.474 17.6743 25.9816 19.1667 24.1406 19.1667"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.1406 12.5C25.9816 12.5 27.474 13.9924 27.474 15.8333C27.474 17.6743 25.9816 19.1667 24.1406 19.1667"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.1668 23.334H14.1668C12.3259 23.334 10.8335 24.8264 10.8335 26.6673"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
